import { STORAGE, API_ENDPOINT } from "../../constants";
import { HTTP } from "../http";
import { StorageService } from "../storage";

export const LoansService = {
  save: (data: {
    period: string,
    loan_credit: string,
    date: string,
    amount: number,
    interest: number,
    total_months: number,
    comments: string
  }) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.post<any, any>(`${API_ENDPOINT}operation/loans`, {
      ...data,
      account,
    });
  },
  list: (period: string) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.get<any, any>(`${API_ENDPOINT}operation/loans/${account}/${period}`);
  },
};
